<template lang="pug">
    .page
        .banner
            img(src="@/assets/img/banner_contact.png")
            .title-container
                .title 联系我们
                .text CONTACT US
        .content-container
            .addr-container
                .addr
                    .title 上海 | SHANGHAI
                    .contact - 地址：上海市静安区威海路233号恒利国际大厦804室
                    .contact - 电话：021-63581828
                    .contact - 传真：021-63581668
                .map
                    img(src="@/assets/img/map_1.png")
            .addr-container
                .addr
                    .title 苏州 | SUZHOU
                    .contact - 地址：苏州工业园区苏虹东路183号
                    .contact(style="text-indent: 4em;") 东沙湖股权投资中心19栋2层西212室
                    .contact - 电话：0512-66969306
                    .contact - 传真：0512-66969306
                .map
                    img(src="@/assets/img/map_2.png")
            .form-container
                .contact
                    .title 提交商业计划，请联系：
                    a.email(href="mailto:bp@dragonrisecapital.com") bp@dragonrisecapital.com
                    .title 如有其他问题，请联系：
                    a.email(href="mailto:info@dragonrisecapital.com") info@dragonrisecapital.com
                .form
                    .title 如果您对我们感兴趣，可留下您的联系方式及留言
                    .form-item
                        .label 姓名：
                        input(v-model="form.name")
                    .form-item
                        .label 公司：
                        input(v-model="form.company")
                    .form-item
                        .label 职位：
                        input(v-model="form.office")
                    .form-item
                        .label 联系电话：
                        input(v-model="form.phone")
                    .form-item
                        .label 电子邮编：
                        input(v-model="form.email")
                    .form-item
                        .label 留言：
                        textarea(v-model="form.message")
                    .btns
                        .btn(@click="handleSubmit") 提交
</template>

<script>
import axios from 'axios'
export default {
    name: 'Contact',
    data() {
        return {
            form: {
                name: '',
                company: '',
                office: '',
                phone: '',
                email: '',
                message: ''
            }
        }
    },
    methods: {
        handleSubmit() {
            if (Object.values(this.form).every(i => i)) axios.post('/api/message', this.form)
        }
    }
}
</script>

<style lang="sass" scoped>
.page
    width: 100%
    padding-top: 60px
    .banner
        width: 100%
        display: flex
        justify-content: center
        align-items: center
        flex-direction: column
        text-align: center
        height: 100px
        position: relative
        img
            display: block
            height: 100%
            width: 100%
            object-fit: cover
        .title-container
            position: absolute
        .title
            font-size: 22px
        .text
            font-size: 12px
            line-height: 1.8
    .content-container
        max-width: 1000px
        margin: 0 auto
        min-height: 1030px
        padding-top: 60px
        .addr-container
            font-size: 14px
            padding: 20px
            .addr
                flex: 4
                .title
                    font-size: 16px
                    font-weight: bold
                    line-height: 2
                .contact
                    font-weight: 400
                    color: #333
                    line-height: 2
            .map
                border: 1px solid #eee
                width: 100%
                border-radius: 4px
                padding: 4px
                img
                    display: block
                    width: 100%
        .form-container
            margin-bottom: 100px
            padding: 20px
            .contact
                flex: 4
                .title
                    font-size: 16px
                    font-weight: bold
                    margin-bottom: 1em
                a   
                    cursor: pointer
                    color: #0066ff
                    text-decoration: underline
                    margin-bottom: 3em
                    display: block
            .form
                flex: 6
                .title
                    font-size: 16px
                    font-weight: bold
                    margin-bottom: 1em
                .form-item
                    color: #333
                    margin-bottom: 10px
                    .label
                        width: 8em
                        font-size: 14px
                    input, textarea
                        width: 100%
                        line-height: 2
                        border: 1px solid #eee
                        padding: 0 0.5em
                        box-sizing: border-box
                .btns
                    display: flex
                    justify-content: flex-end
                    .btn
                        cursor: pointer
                        border: 1px solid #eee
                        font-size: 14px
                        color: #333
                        line-height: 2
                        padding: 1em
                        width: 100%
                        text-align: center
@media screen and (min-width: 1024px)
    .page
        width: 100%
        padding-top: 100px
        .banner
            display: flex
            justify-content: center
            flex-direction: column
            align-items: center
            height: 325px
            width: 100%
            text-align: center
            position: relative
            img
                height: 100%
                width: 100%
                object-fit: cover
                display: block
            .title-container
                position: absolute
            .title
                font-size: 22px
            .text
                font-size: 12px
                line-height: 2
        .content-container
            max-width: 1000px
            margin: 0 auto
            min-height: 1030px
            padding-top: 60px
            .addr-container
                font-size: 14px
                display: flex
                justify-content: center
                margin-bottom: 43px 
                .addr
                    flex: 4
                    .title
                        font-size: 16px
                        font-weight: bold
                        line-height: 2
                    .contact
                        font-weight: 400
                        color: #333
                        line-height: 2
                .map
                    border: 1px solid #eee
                    width: 60%
                    border-radius: 4px
                    padding: 4px
                    img
                        display: block
                        width: 100%
            .form-container
                display: flex
                margin-bottom: 100px
                .contact
                    flex: 4
                    .title
                        font-size: 16px
                        font-weight: bold
                        margin-bottom: 1em
                    a   
                        cursor: pointer
                        color: #0066ff
                        text-decoration: underline
                        margin-bottom: 3em
                        display: block
                .form
                    flex: 6
                    .title
                        font-size: 16px
                        font-weight: bold
                        margin-bottom: 1em
                    .form-item
                        color: #333
                        display: flex
                        margin-bottom: 10px
                        .label
                            width: 8em
                            font-size: 14px
                        input, textarea
                            flex: 1
                            line-height: 2
                            border: 1px solid #eee
                            padding: 0 0.5em
                            box-sizing: border-box
                    .btns
                        display: flex
                        justify-content: flex-end
                        .btn
                            cursor: pointer
                            border: 1px solid #eee
                            font-size: 14px
                            color: #333
                            line-height: 2
                            padding: 0 1em
                            width: auto         
</style>